<p-dialog
  [visible]="visible()"
  [resizable]="false"
  appendTo="body"
  [modal]="true"
  [breakpoints]="{ '767px': '100vw' }"
  [style]="{ width: '500px' }"
  styleClass="no-header-modal"
  (onHide)="onHide()"
  aria-label="pending-actions-dialog"
>
  <ng-template pTemplate="header" styleClass="hidden" />

  <ng-template pTemplate="content" styleClass="p-0">
    <!-- Header -->
    <div
      class="p-3 sticky w-full top-0 right-0 surface-0 z-1 flex align-items-center justify-content-between border-bottom-1 border-300"
    >
      <h4 class="text-base font-normal mb-0">
        {{ 'SUBSCRIPTIONS.WHATS_PENDING_TITLE' | translate }}
      </h4>
      <div
        class="fa fa-times text-xl text-600 cursor-pointer"
        (click)="onClose()"
        aria-label="close-pending-actions-popup"
      ></div>
    </div>
    <!-- Header -->

    <!-- Content -->
    @if (pendingDetails()) {
      <div class="surface-100 p-4">
        <div class="mb-4">
          <p class="text-sm text-600 mb-3">
            {{ 'SUBSCRIPTIONS.PENDING_ACTIONS_INFO' | translate }}
          </p>
        </div>
        <!-- Pending Items List -->
        <div class="space-y-3">
          <!-- Agreement / Waiver Signing - Always show -->
          <div
            class="flex align-items-center p-3 surface-0 border-round shadow-1"
          >
            <div
              class="flex align-items-center justify-content-center w-2rem h-2rem border-round-sm mr-3"
              [ngClass]="
                pendingDetails().isWaiverRequired
                  ? 'bg-red-500 text-white'
                  : 'bg-green-500 text-white'
              "
            >
              <i
                class="text-sm"
                [ngClass]="
                  pendingDetails().isWaiverRequired
                    ? 'fa fa-times'
                    : 'fa fa-check'
                "
                [attr.aria-label]="
                  pendingDetails().isWaiverRequired
                    ? 'waiver-pending'
                    : 'waiver-completed'
                "
              ></i>
            </div>
            <div class="flex-1">
              <h6 class="font-medium text-900 mb-1">
                {{ 'SUBSCRIPTIONS.AGREEMENT_WAIVER_SIGNING' | translate }}
              </h6>
              @if (pendingDetails().isWaiverRequired) {
                <p class="text-xs text-600 mb-0">
                  {{
                    'SUBSCRIPTIONS.AGREEMENT_WAIVER_PENDING_DESCRIPTION'
                      | translate
                  }}
                </p>
              }
              @if (!pendingDetails().isWaiverRequired) {
                <p class="text-xs text-600 mb-0">
                  {{
                    'SUBSCRIPTIONS.AGREEMENT_WAIVER_COMPLETED_DESCRIPTION'
                      | translate
                  }}
                </p>
              }
            </div>
          </div>
          <!-- Payment Token Required - Show only if autopay is enabled -->
          @if (isAutopayEnabled()) {
            <div
              class="flex align-items-center p-3 surface-0 border-round shadow-1"
            >
              <div
                class="flex align-items-center justify-content-center w-2rem h-2rem border-round-sm mr-3"
                [ngClass]="
                  pendingDetails().isTokenRequired
                    ? 'bg-red-500 text-white'
                    : 'bg-green-500 text-white'
                "
              >
                <i
                  class="text-sm"
                  [ngClass]="
                    pendingDetails().isTokenRequired
                      ? 'fa fa-times'
                      : 'fa fa-check'
                  "
                  [attr.aria-label]="
                    pendingDetails().isTokenRequired
                      ? 'payment-pending'
                      : 'payment-completed'
                  "
                ></i>
              </div>
              <div class="flex-1">
                <h6 class="font-medium text-900 mb-1">
                  {{ 'SUBSCRIPTIONS.PAYMENT_TOKEN_REQUIRED' | translate }}
                </h6>
                @if (pendingDetails().isTokenRequired) {
                  <p class="text-xs text-600 mb-0">
                    {{ 'SUBSCRIPTIONS.PAYMENT_TOKEN_DESCRIPTION' | translate }}
                  </p>
                }
              </div>
            </div>
          }
          <!-- Mandatory Fields - Always show -->
          <div
            class="flex align-items-start p-3 surface-0 border-round shadow-1"
          >
            <div
              class="flex align-items-center justify-content-center w-2rem h-2rem border-round-sm mr-3 mt-1"
              [ngClass]="
                pendingDetails().mandatoryFieldsRequired &&
                pendingDetails().mandatoryFieldsRequired.length > 0
                  ? 'bg-red-500 text-white'
                  : 'bg-green-500 text-white'
              "
            >
              <i
                class="text-sm"
                [ngClass]="
                  pendingDetails().mandatoryFieldsRequired &&
                  pendingDetails().mandatoryFieldsRequired.length > 0
                    ? 'fa fa-times'
                    : 'fa fa-check'
                "
                [attr.aria-label]="
                  pendingDetails().mandatoryFieldsRequired &&
                  pendingDetails().mandatoryFieldsRequired.length > 0
                    ? 'mandatory-fields-pending'
                    : 'mandatory-fields-completed'
                "
              ></i>
            </div>
            <div class="flex-1">
              <h6 class="font-medium text-900 mb-2">
                {{ 'SUBSCRIPTIONS.MANDATORY_FIELDS_REQUIRED' | translate }}
              </h6>
              @if (
                pendingDetails().mandatoryFieldsRequired &&
                pendingDetails().mandatoryFieldsRequired.length > 0
              ) {
                <div>
                  <p class="text-xs text-600 mb-2">
                    {{
                      'SUBSCRIPTIONS.MANDATORY_FIELDS_DESCRIPTION' | translate
                    }}
                  </p>
                  <div class="space-y-1">
                    @for (
                      field of pendingDetails().mandatoryFieldsRequired;
                      track field
                    ) {
                      <div
                        class="flex align-items-center text-xs text-900 mb-1"
                      >
                        <i class="fa fa-circle text-xxs mr-2 text-600"></i>
                        <span>{{ formatFieldName(field) }}</span>
                      </div>
                    }
                  </div>
                </div>
              }
              @if (
                !pendingDetails().mandatoryFieldsRequired ||
                pendingDetails().mandatoryFieldsRequired.length === 0
              ) {
                <p class="text-xs text-600 mb-0">
                  {{
                    'SUBSCRIPTIONS.MANDATORY_FIELDS_COMPLETED_DESCRIPTION'
                      | translate
                  }}
                </p>
              }
            </div>
          </div>
          <!-- All Requirements Completed -->
          @if (
            !pendingDetails().isWaiverRequired &&
            (!isAutopayEnabled() || !pendingDetails().isTokenRequired) &&
            (!pendingDetails().mandatoryFieldsRequired ||
              pendingDetails().mandatoryFieldsRequired.length === 0)
          ) {
            <div class="text-center py-4">
              <i class="fa fa-check-circle text-green-500 text-3xl mb-3"></i>
              <p class="text-sm text-600">
                {{ 'SUBSCRIPTIONS.NO_PENDING_ACTIONS' | translate }}
              </p>
            </div>
          }
        </div>
      </div>
    }
    <!-- Content -->

    <!-- Modal Footer -->
    <div
      class="flex align-items-center justify-content-end px-4 py-3 border-top-1 border-300"
    >
      <p-button
        [label]="'common.BUTTONS.BTN_CLOSE' | translate"
        styleClass="p-button-outlined text-sm"
        (click)="onClose()"
        aria-label="close-pending-actions-button"
      />
    </div>
    <!-- Modal Footer -->
  </ng-template>
</p-dialog>
